// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/navigation-methods.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/navigation-methods/navigation-methods.js';

mount([g0]);
